export interface MccCode {
  code: string;
  description: string;
}

export const mccCodes: MccCode[] = [
  { code: "742", description: "VETERINARIA" },
  { code: "744", description: "Carefree Resorts" },
  { code: "763", description: "COOPERATIVA AGRÍCOLA" },
  { code: "780", description: "SERVIÇOS DE PAISAGISMO E HORTICULTURA" },
  {
    code: "1520",
    description: "EMPREITEIROS EM GERAL - COMERCIAL E RESIDENCIAL",
  },
  {
    code: "1711",
    description: "PREST. DE SERV. PARA AR COND., ENCANAMENTO E AQUEC.",
  },
  { code: "1731", description: "ELETRICISTAS E SERVIÇOS ELÉTRICOS" },
  { code: "1740", description: "PEDREIROS E SERVIÇOS DE INSTALAÇÃO" },
  { code: "1750", description: "MARCENEIROS E SERVIÇOS DE CARPINTARIA" },
  { code: "1761", description: "METALURGICOS" },
  { code: "1771", description: "EMPREITEIO PARA SERVIÇOS ESPECIALIZADO" },
  {
    code: "1799",
    description: "DEMAIS SVS DE REFORMA E CONSTRUÇÃO NÃO-CLASSIFICADOS",
  },
  { code: "2741", description: "EDITORAS - PUBLICAÇÕES E IMPRESSÕES" },
  {
    code: "2791",
    description: "TYPESETTING, PLATE MAKING AND RELATED SERVICES",
  },
  { code: "2842", description: "SERVIÇOS DE LIMPEZA E POLIMENTO" },
  { code: "4011", description: "TRANSPORTE FERROVIÁRIO DE CARGA" },
  {
    code: "4111",
    description: "TRANSPORTE LOCAL DE PASSAGEIROS, INCLUINDO BALSAS",
  },
  {
    code: "4112",
    description: "TRANSPORTE DE PASSAGEIROS EM TREM (LONGA DISTÂNCIA)",
  },
  { code: "4119", description: "AMBULANCIAS" },
  { code: "4121", description: "LIMUSINES E TÁXIS (TAXICABS AND LIMOUSINES)" },
  { code: "4131", description: "COMPANHIAS DE ONIBUS" },
  {
    code: "4214",
    description: "TRANSPORTE DE CARGA RODOVIÁRIO E ARMAZENAMENTO",
  },
  { code: "4215", description: "CORREIOS - AÉREO, TERRESTRE E TRANSITÓRIOS" },
  {
    code: "4225",
    description: "ARMAZENAM. PROD AGRÍCOLAS,MERCAD REFRIGERADAS,BENS DOMÉSTICO",
  },
  { code: "4411", description: "LINHAS DE CRUZEROS (CRUISE LINES)" },
  {
    code: "4457",
    description: "ALUGUEL E ARRENDAMENTO DE BARCOS, ESQUIS E IATES",
  },
  { code: "4468", description: "MARINAS, SERVIÇOS E FORNECEDORES" },
  { code: "4511", description: "OUTRAS CIAS AÉREAS" },
  { code: "4582", description: "AEROPORTOS E SERVIÇOS LIGADOS A AERONAVES" },
  { code: "4722", description: "AGÊNCIAS DE VIAGENS (TRAVEL AGENCIES)" },
  { code: "4723", description: "AGÊNCIAS DE VIAGEM TUI (TUI TRAVEL AGENCY)" },
  { code: "4784", description: "PEDÁGIOS" },
  { code: "4789", description: "SERVIÇOS DE TRANSPORTE" },
  { code: "4812", description: "TELEFONES E EQUIPAMENTOS DE TELECOMUN." },
  {
    code: "4813",
    description: "SERVIÇOS DE TELEC.- CHAM. LOCAIS E LONGA DISTÂNCIA",
  },
  { code: "4814", description: "SERVIÇOS DE TELECOMUNICAÇÃO" },
  {
    code: "4816",
    description: "REDES DE COMPUTADORES / SERVIÇOS DE INFORMAÇÃO",
  },
  { code: "4821", description: "TELEGRAFO" },
  {
    code: "4829",
    description: "ORDENS DE PAGAMENTO POR TRANSFERÊNCIA BANCÁRIA",
  },
  {
    code: "4899",
    description: "SERVIÇOS DE TV A CABO/PAGA (CABLE/PAY TV SERVICES)",
  },
  {
    code: "4900",
    description: "UTILID./ELEC/GAS/AGUÁ/SANI (UT../ELEC/GAS/H2O/SANI)",
  },
  {
    code: "5013",
    description: "ATACADISTAS E DISTRIBUIDORES DE ACESSÓRIOS DE VEÍCULOS",
  },
  {
    code: "5021",
    description: "MÓVEIS PARA ESCRITÓRIOS (COMMERCIAL FURNITURE)",
  },
  {
    code: "5039",
    description: "MATERIAL PARA CONSTRUÇÃO E AFINS (CONST. MAT. - DEF)",
  },
  {
    code: "5044",
    description: "A/D DE EQUIPAMENTOS DE FOTOGRAFIA, CÓPIA E MICROFILME",
  },
  { code: "5045", description: "COMPUTADORES, EQUIPAMENTOS E SOFTWARES" },
  { code: "5046", description: "A/D DE MÁQUINAS E EQUIPAMENTOS PARA EC" },
  {
    code: "5047",
    description: "A/D DE EQUIPAMENTO HOSPITALARES, MÉDICOS E OFTÁLMICOS",
  },
  {
    code: "5051",
    description: "CENTROS DE SERVIÇOS DE METAIS (METAL SERVICE CENTERS)",
  },
  { code: "5065", description: "LOJA ARTIGOS ELETRÔNICOS" },
  {
    code: "5072",
    description: "EQUIP./DISTRIB. DE HARDWARE (HARDWARE EQUIP.SUPPLIES)",
  },
  {
    code: "5074",
    description: "EQUIP. DE AQUECIMENTO/ENCANAMENTO (PLUMB./HEAT. E.)",
  },
  {
    code: "5085",
    description: "A/D DE SUPRIMENTOS INDUSTRIAIS (NÃO CLASSIFICADO EM OUTRO)",
  },
  { code: "5094", description: "JOALHERIA, PEDRAS PRECIOSAS, METAIS" },
  {
    code: "5099",
    description: "ATACADISTAS E DISTRIBUIDORES DE MERCADORIAS DURÁVEIS",
  },
  {
    code: "5111",
    description: "A/D DE ARTIGOS DE PAPELARIA E SUPRIMENTOS PARA ESCRITÓRIO",
  },
  {
    code: "5122",
    description: "FARMACEUTICOS/DROGAS (DRUGS/DRUGGISTS SUNDRIES)",
  },
  { code: "5131", description: "A/D DE TECIDOS E PRODUTOS DE ARMARINHO" },
  { code: "5137", description: "ATACADISTAS E DISTRIBUIDORES DE ROUPAS" },
  { code: "5139", description: "ATACADISTAS E DISTRIBUIDORES DE CALÇADOS" },
  {
    code: "5169",
    description: "A/D DE PRODUTOS QUIMICOS E SEMELHANTES (N CLASSIF. EM OUTRO)",
  },
  {
    code: "5172",
    description: "PRODUTOS DE PETRÓLEO (PETROLEUM/PETROLEUM PRODUCTS)",
  },
  {
    code: "5192",
    description: "ATAC. E DISTRIB. DE LIVROS, PERIÓDICOS E JORNAIS",
  },
  {
    code: "5193",
    description: "ATACADISTAS E DISTRIBUIDORES DE FLORES, PLANTAS E SEMENTES",
  },
  {
    code: "5198",
    description: "PINTURA, POLIMENTO E SUPRIM. (PAN.,VARN. & SUPPLIES)",
  },
  {
    code: "5199",
    description: "A/D DE MERCADORIAS NÃO DURÁVEIS (NÃO CLASSIF. EM OUTRO)",
  },
  {
    code: "5200",
    description: "LOJAS DE MATERIAL DE CONSTRUÇÃO (PEQUENO/MÉDIO PORTE)",
  },
  {
    code: "5211",
    description: "LOJAS DE MATERIAL DE CONSTRUÇÃO-PRODUTOS BRUTOS (EX: TIJOLO)",
  },
  { code: "5231", description: "LOJAS DE VIDROS, TINTAS E P..." },
  { code: "5271", description: "LOJAS MÓVEIS - TRAILERS" },
  { code: "5300", description: "PONTOS DE VENDAS PARA WHOLESALERS" },
  { code: "5310", description: "LOJAS DE DEPARTAMENTOS" },
  { code: "5311", description: "LOJAS DE DEPARTAMENTOS" },
  { code: "5331", description: "LOJAS DE VARIEDADES" },
  { code: "5399", description: "LOJAS DE MERCADORIAS EM GERAL" },
  { code: "5411", description: "MERCADOS, SUPERMERCADOS E GROCERY STORES" },
  { code: "5422", description: "FRIGORÍFICOS" },
  { code: "5441", description: "LOJAS DE DOCES" },
  { code: "5451", description: "LOJAS LATICÍNIOS" },
  { code: "5462", description: "PADARIAS" },
  { code: "5499", description: "LOJAS DE PRODUTOS DE ALIMENTAÇÃO" },
  {
    code: "5511",
    description: "CONCESSIONÁRIAS DE AUTOMÓVEIS - NOVOS E USADOS",
  },
  {
    code: "5521",
    description: "ATACADISTAS E DISTRIBUIDORES DE CARROS E CAMINHÕES",
  },
  { code: "5531", description: "LOJAS DE PEÇAS E ACESSÓRIOS DE AUTOMÓVEIS" },
  { code: "5532", description: "PNEUS" },
  { code: "5533", description: "LOJAS DE BATERIAS DE AUTOMÓVEIS" },
  { code: "5541", description: "POSTOS DE GASOLINA COM SERVIÇOS" },
  { code: "5542", description: "POSTOS DE GASOLINA" },
  { code: "5551", description: "REBOQUES, ACESSÓRIOS E MOTORIZADOS" },
  { code: "5592", description: "MOTOS, ATV E ACESSÓRIOS" },
  { code: "5598", description: "EMPREENDIMENTOS DE VENDAS DE CARROS" },
  { code: "5599", description: "VEÍCULOS DIVERSOS" },
  { code: "5611", description: "LOJAS DE ROUPA MASCULINA" },
  { code: "5621", description: "LOJAS DE ROUPA FEMININA" },
  { code: "5631", description: "LOJAS DE ACESSÓRIOS FEMININOS" },
  { code: "5641", description: "LOJAS DE ROUPAS INFANTIS" },
  { code: "5651", description: "LOJAS DE ROUPAS FAMILIARES" },
  { code: "5655", description: "LOJAS DE SURF E BANHO" },
  { code: "5661", description: "LOJAS DE CALÇADOS" },
  { code: "5681", description: "LOJAS DE PELE" },
  { code: "5691", description: "LOJAS DE MASCULINAS E FEMININAS" },
  { code: "5697", description: "CORTES DE CABELO, SALÕES DE BELEZA" },
  { code: "5698", description: "PERUQUERIAS" },
  { code: "5699", description: "LOJAS DE ACESSÓRIOS" },
  { code: "5712", description: "MÓVEIS, ARTIGOS DE CASA E EQUIPAMENTOS" },
  { code: "5713", description: "LOJAS DE TAPETES E CARPETE" },
  { code: "5714", description: "MÓVEIS E ARTIGOS DE MESA" },
  { code: "5718", description: "LOJAS DE LAREIRAS" },
  { code: "5719", description: "LOJAS DE MÓVEIS E DECORAÇÃO" },
  { code: "5722", description: "LOJAS DE ELETRODOMÉSTICOS" },
  { code: "5732", description: "LOJAS DE ELETRÔNICOS" },
  { code: "5733", description: "LOJAS DE APARELHOS DE SOM" },
  { code: "5734", description: "LOJAS DE EQUIPAMENTO DE ESCRITÓRIO, DESKTOP" },
  { code: "5735", description: "LOJAS DE JOGOS - SOFTWARE" },
  { code: "5811", description: "CANTINAS E RESTAURANTES" },
  { code: "5812", description: "ESTABELECIMENTOS DE COMIDA RÁPIDA" },
  { code: "5813", description: "BARES, TAVERNAS, NIGHTCLUBS" },
  { code: "5814", description: "CAFETERIAS" },
  { code: "5912", description: "LOJAS DE PRODUTOS FARMACÊUTICOS" },
  { code: "5921", description: "LOJAS DE BEBIDAS ALCOÓLICAS" },
  { code: "5931", description: "LOJAS DE ANTIGUIDADES" },
  { code: "5932", description: "SECOND HAND MERCHANDISE" },
  { code: "5933", description: "LOJAS DE PENHORA" },
  { code: "5935", description: "LOJAS DE ARTE, ARTESANATO E NOVELARIAS" },
  { code: "5937", description: "LOJAS DE ANTIGUIDADES E REPRODUÇÕES" },
  { code: "5940", description: "LOJAS DE BICICLETAS" },
  { code: "5941", description: "LOJAS DE MATERIAL DE PESCA" },
  { code: "5942", description: "LOJAS DE ARTIGOS DE CORRIDAS" },
  {
    code: "5943",
    description: "LOJAS DE ARTIGOS DE ESCRITÓRIO, PAPELARIA E IMPRESSÕES",
  },
  { code: "5944", description: "LOJAS DE RELÓGIOS E JÓIAS" },
  { code: "5945", description: "LOJAS DE BRINQUEDOS E JOGOS" },
  { code: "5946", description: "LOJAS DE ARTESANATO E BORDADOS" },
  { code: "5947", description: "LOJAS DE ARTIGOS DE BARBEARIA" },
  { code: "5948", description: "LOJAS DE EQUIPAMENTO DE ARTESANATO" },
  { code: "5949", description: "LOJAS DE COSTURA" },
  { code: "5950", description: "LOJAS DE ARTIGOS DE VIDRO" },
  { code: "5960", description: "LOJAS DIRETAS DE MARKETING E CATÁLOGOS" },
  { code: "5962", description: "TELEMARKETING" },
  {
    code: "5963",
    description: "LOJAS DE COBRANÇA POR PORTADOR - PRODUTOS FÍSICOS",
  },
  { code: "5964", description: "DIRECT MARKETING" },
  { code: "5965", description: "LOJAS DE COBRANÇA POR PORTADOR - MEMBROS" },
  { code: "5966", description: "OUTRAS LOJAS DE TELECOMERCIALIZAÇÃO" },
  { code: "5967", description: "VENDAS DIRETAS POR TELEMARKETING" },
  { code: "5968", description: "LOJAS DE COBRANÇA POR PORTADOR - RECORRENTES" },
  {
    code: "5969",
    description: "LOJAS DE COBRANÇA POR PORTADOR NÃO CLASIFICADAS",
  },
  { code: "5970", description: "LOJAS DE ARTIGOS DE ARTESANATO" },
  { code: "5971", description: "LOJAS DE ARTESANATO E ARTIGOS ARTESANAIS" },
  { code: "5972", description: "LOJAS DE SELOS" },
  { code: "5973", description: "ACESSÓRIOS DE ÓCULOS" },
  { code: "5975", description: "LOJAS DE PINTURAS" },
  { code: "5976", description: "LOJAS DE ARTIGOS DE EQUIPAMENTO" },
  {
    code: "5977",
    description: "LOJAS DE COPIADORAS E EQUIPAMENTOS DE ESCRITÓRIO",
  },
  {
    code: "5978",
    description: "LOJAS DE EQUIPAMENTO DE ARTESANATO E ARTESANATO",
  },
  { code: "5983", description: "LOJAS DE COMBUSTÍVEIS" },
  { code: "5992", description: "LOJAS DE FLORES" },
  { code: "5993", description: "TABACOS, TABACARIAS" },
  { code: "5994", description: "LOJAS DE ARTIGOS DE ARTESANATO" },
  { code: "5995", description: "LOJAS DE PET SHOP" },
  { code: "5996", description: "LOJAS DE PISCINA" },
  { code: "5997", description: "LOJAS DE MATERIAIS ELÉTRICOS" },
  { code: "5998", description: "LOJAS DE EQUIPAMENTOS DIVERSOS E MISCELÂNEAS" },
  { code: "5999", description: "LOJAS DIVERSAS" },
  {
    code: "6010",
    description: "INSTITUIÇÕES FINANCEIRAS - MANUAL CASH DISBURSEMENTS",
  },
  {
    code: "6011",
    description: "INSTITUIÇÕES FINANCEIRAS - MANUAL CASH DISBURSEMENTS",
  },
  { code: "6012", description: "INSTITUIÇÕES FINANCEIRAS - QUASI CASH" },
  { code: "6051", description: "NÃO FINANCEIROS - QUASI CASH" },
  { code: "6211", description: "TÍTULOS MOBILIÁRIOS" },
  { code: "6513", description: "PROPRIETÁRIO DE IMÓVEIS" },
  { code: "7011", description: "HOTÉIS" },
  { code: "7012", description: "TIMESHARE" },
  { code: "7032", description: "CAMPING DE RECREIO E ESCOLAS" },
  { code: "7033", description: "ACAMPAMENTOS E PARQUES" },
  { code: "7210", description: "SERVIÇOS DE LAVANDERIA" },
  { code: "7211", description: "SERVIÇOS DE LAVANDERIA" },
  { code: "7216", description: "LAVANDERIA A SECO" },
  { code: "7217", description: "LAVANDERIA E LIMPEZA" },
  { code: "7221", description: "FOTOCOPIADORAS E SERVIÇOS" },
  { code: "7230", description: "BARBEARIAS" },
  { code: "7251", description: "SERVIÇOS DE REPARAÇÃO" },
  { code: "7261", description: "FUNERAL E CREMAÇÃO" },
  { code: "7273", description: "SERVIÇOS DE CONSULTORIA" },
  { code: "7276", description: "SERVIÇOS DE TAX PREPARATION" },
  { code: "7277", description: "SERVIÇOS DE CONSULTORIA" },
  { code: "7278", description: "COBRANÇA E SERVIÇOS DE CRÉDITO - BUREAUS" },
  { code: "7280", description: "SERVIÇOS PARTICULARES" },
  { code: "7296", description: "CONTRATOS E PASSAGENS" },
  { code: "7297", description: "MASSAGEM PARLORS" },
  { code: "7298", description: "SERVIÇOS MÉDICOS E DE SAÚDE" },
  { code: "7299", description: "SERVIÇOS MISCELÂNEOS" },
  { code: "7311", description: "AGÊNCIAS DE PUBLICIDADE" },
  { code: "7321", description: "SERVIÇOS DE CRÉDITO" },
  { code: "7322", description: "SERVIÇOS DE COBRANÇA" },
  { code: "7333", description: "SERVIÇOS DE PLANO DE MARKETING" },
  { code: "7338", description: "SERVIÇOS DE CÓPIA E REPRODUÇÃO" },
  { code: "7339", description: "SERVIÇOS DE PLANO DIVERSOS" },
  { code: "7342", description: "LOJAS DE CONGELAMENTO" },
  { code: "7349", description: "SERVIÇOS DE DIVERSOS PLANOS" },
  { code: "7361", description: "AGÊNCIAS DE EMPREGO" },
  { code: "7372", description: "SERVIÇOS DE COMPUTADORES" },
  { code: "7375", description: "INFORMAÇÃO RETRIEVAL SERVICES" },
  { code: "7379", description: "SERVIÇOS DE COMPUTADORES" },
  { code: "7392", description: "SERVIÇOS DE CONSULTORIA (NÃO CLASIFICADOS)" },
  {
    code: "7393",
    description: "AGÊNCIAS DE DETETIVES, PROTECÇÃO E DE SEGURANÇA",
  },
  {
    code: "7394",
    description: "ALUGUEL DE EQUIPAMENTO E MOBÍLIA DE ESCRITÓRIOS",
  },
  { code: "7395", description: "LABORATÓRIOS FOTOGRÁFICOS" },
  { code: "7399", description: "SERVIÇOS DE NEGÓCIOS" },
  { code: "7511", description: "PARADA DE CAMINHÕES (TRUCK STOP)" },
  {
    code: "7512",
    description: "ALUGUEL DE AUTOMÓVEIS (AUTOMOBILE RENTAL AGENCY)",
  },
  {
    code: "7513",
    description: "ALUGUEL DE CAMINHÕES (TRUCK/UTILITY TRAILER RENTALS)",
  },
  {
    code: "7519",
    description: "ALUGUEL DE MOTOR HOME (MOTOR HOME/RV RENTALS)",
  },
  { code: "7523", description: "ESTACIONAMENTOS E GARAGENS DE CARRO" },
  { code: "7531", description: "FUNILARIAS E PINTURA AUTOMOTIVA" },
  { code: "7534", description: "BORRACHARIAS" },
  { code: "7535", description: "LOJAS DE PINTURA DE AUTTOMÓVEIS" },
  { code: "7538", description: "SERVIÇOS PARA CARROS (NÃO CONCESIONARIA)" },
  { code: "7542", description: "LAVA JATO" },
  { code: "7549", description: "GUINCHO" },
  { code: "7622", description: "CONSERTO DE EQUIP. AUDIO E TV" },
  { code: "7623", description: "CONSERTO DE AR CONDICIONADO" },
  { code: "7629", description: "CONSERTO DE ELETRONICOS" },
  { code: "7631", description: "CONSERTO DE RELÓGIOS E JÓIAS" },
  { code: "7641", description: "RESTAURAÇÃO DE MÓVEIS (FURNITURE REPAIR)" },
  { code: "7692", description: "SERRALHEIROS E SOLDADORES" },
  {
    code: "7699",
    description: "LOJA DE CONSERTOS GERAIS E SERVIÇOS RELACIONADOS",
  },
  { code: "7829", description: "PRODUTORES E DISTRIBUIDORES DE FILMES" },
  { code: "7832", description: "CINEMAS, PRODUÇÕES CINEMATOGRÁFICAS" },
  { code: "7841", description: "LOJAS DE VIDEOS" },
  { code: "7911", description: "DANÇA (ESTUDIOS, ESCOLAS E SALÕES)" },
  { code: "7922", description: "TEATROS, PRODUC. TEATR. E ESPECTAC." },
  {
    code: "7929",
    description: "BANDAS,ORQUESTRAS,ARTISTAS DIVERSOS(N CLASSIFICADO EM OUTRO)",
  },
  { code: "7932", description: "BARES DE SINUCA" },
  { code: "7933", description: "BOLICHE" },
  { code: "7941", description: "QUADRAS DE ESPORTE / PROPAGANDA ESPORTIVA" },
  { code: "7991", description: "ATRAÇÕES TURÍSTICAS E EXPOSIÇÕES" },
  { code: "7992", description: "AULAS DE GOLF PUBLICA" },
  {
    code: "7993",
    description: "FORNECEDORES DE MÁQUINAS DE VIDEOGAME OU JOGOS",
  },
  {
    code: "7994",
    description: "LOJAS DE DIVERSÃO / VIDEO GAME / LAN HOUSE / CIBER CAFÉ",
  },
  { code: "7995", description: "CASSINOS, LOTERIAS E JOGOS DE AZAR" },
  { code: "7996", description: "PARQUE DE DIVERSAO, CIRCO E AFINS" },
  { code: "7997", description: "ACADEMIAS / CLUBES" },
  { code: "7998", description: "AQUÁRIOS E ZOOLÓGICOS" },
  { code: "7999", description: "SERVIÇOS DE RECREAÇÃO E FESTAS" },
  { code: "8011", description: "MÉDICOS (CLÍNICAS E CONSULTÓRIOS)" },
  {
    code: "8021",
    description: "DENTISTAS E ORTODONTISTAS (CLÍNICAS E CONSULTÓRIOS)",
  },
  { code: "8031", description: "OSTEOPATAS" },
  { code: "8041", description: "QUIROPRAXIA" },
  { code: "8042", description: "OFTAMOLOGISTA E OPTOMETRISTAS" },
  { code: "8043", description: "OPTICIANS, OPTICAL GOODS, AND EYEGLASSES" },
  { code: "8049", description: "TRATAMENTOS PODIÁTRICOS" },
  {
    code: "8050",
    description: "CASAS DE REPOUSO, CLÍN. DE RECUPERAÇÃO E ENFERMAGEM",
  },
  { code: "8062", description: "HOSPITAIS" },
  { code: "8071", description: "ANALISES CLÍNICAS MÉDICAS E DENTAIS" },
  {
    code: "8099",
    description: "MEDICINA EM GERAL E PRATICANTES DE SERVIÇOS DE SAÚDE",
  },
  { code: "8111", description: "SERVIÇOS JURÍDICOS - ADVOGADOS" },
  {
    code: "8211",
    description: "EDUCAÇÃO PRIMÁRIA E SECUNDÁRIA (ELEM./SEC.S.)",
  },
  {
    code: "8220",
    description: "UNIVERSIDADES E FACULDADES (COLLEGES/UNIV/JC/PROF.)",
  },
  {
    code: "8241",
    description: "EDUACAÇÃO A DISTÂNCIA (CORRESPONDENCE SCHOOLS)",
  },
  {
    code: "8244",
    description: "ESCOLA DE COMÉRCIOS E SECRETARIADO (BUS./SEC. SCHOOL)",
  },
  {
    code: "8249",
    description: "ESCOLA DE NEGÓCIOS/VOCAÇÕES (TRADE/VOCATIONS S.)",
  },
  { code: "8299", description: "COLEGIOS (SCHOOLS)" },
  {
    code: "8351",
    description: "SERVIÇOS DE CUIDADOS DE CRIANÇAS (CHILD CARE SVCS)",
  },
  {
    code: "8398",
    description: "ORGANIZAÇÕES DE SERVIÇOS BENEFICENTES E SOCIAIS",
  },
  { code: "8641", description: "ASSOCIAÇÕES CÍVICAS E SOCIAIS" },
  { code: "8651", description: "ORGANIZAÇÕES POLITICAS" },
  { code: "8661", description: "ORGANIZAÇÕES RELIGIOSAS" },
  { code: "8675", description: "ASSOCIAÇÃO DE CARROS" },
  {
    code: "8699",
    description: "ORG. SIND., ASSOC. CULT. E OTRS ASSOC. NÃO CLASSIF.",
  },
  {
    code: "8734",
    description: "LABORATÓRIOS DE TESTE (PARA TESTES NÃO MÉDICOS)",
  },
  { code: "8911", description: "ARQUIRETURA, ENGENHARIA E AGRIMENSURA" },
  {
    code: "8931",
    description: "CONTABILIDADE, AUDITORIA E SERVIÇOS DE CONTABILIDADE",
  },
  {
    code: "8999",
    description: "OUTROS SERVIÇOS PROFISSIONAIS DE ESPECIALIZADOS",
  },
  {
    code: "9211",
    description: "PENSÃO ALIMENTÍCIA (COURT COSTS/ALIMONY/SUPPORT)",
  },
  { code: "9222", description: "MULTAS (FINES)" },
  {
    code: "9223",
    description: "PAGAMENTOS DE TÍTULOS E FINANÇAS (BAIL AND BOND P.)",
  },
  { code: "9311", description: "PAGAMENTOS DE IMPOSTOS (TAX PAYMENTS)" },
  {
    code: "9399",
    description: "SERVIÇOS GOVERNAMENTAIS (GOVT SERV - DEFAULT)",
  },
  { code: "9402", description: "POSTAGENS (POSTAGE STAMPS)" },
  {
    code: "9405",
    description: "COMPRAS GOVERNAMENTAIS (INTRA-GOVERNMENT PURCHASES)",
  },
  {
    code: "9406",
    description: "Loteria de Propriedade do Governo (Países Específicos)",
  },
  {
    code: "9950",
    description: "DEPART. DE COMPRAS (INTRA- COMPANY PURCHASES)",
  },
];
